import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-faf1c7b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "subject-header"
};
const _hoisted_2 = {
  class: "header-content"
};
const _hoisted_3 = {
  class: "subject-img"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  class: "subject-img-content"
};
const _hoisted_6 = {
  class: "subject-title"
};
const _hoisted_7 = {
  class: "subject-introduction"
};
const _hoisted_8 = {
  class: "subject-website"
};
const _hoisted_9 = {
  class: "subject-content"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subject-header"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-info"
}, "信息还在建设中，敬请期待...", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_update_time = _resolveComponent("update-time");
  const _component_newslist = _resolveComponent("newslist");
  const _component_platform = _resolveComponent("platform");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_t_layout = _resolveComponent("t-layout");
  return _openBlock(), _createBlock(_component_t_layout, {
    class: "subject-detail"
  }, {
    default: _withCtx(() => {
      var _ctx$subjectInfoData, _ctx$subjectInfoData2, _ctx$subjectInfoData3, _ctx$subjectInfoData4, _ctx$subjectInfoData5;
      return [_ctx.subjectInfoData ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: (_ctx$subjectInfoData = _ctx.subjectInfoData) === null || _ctx$subjectInfoData === void 0 ? void 0 : _ctx$subjectInfoData.general_image,
        alt: (_ctx$subjectInfoData2 = _ctx.subjectInfoData) === null || _ctx$subjectInfoData2 === void 0 ? void 0 : _ctx$subjectInfoData2.name
      }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("h1", _hoisted_6, _toDisplayString((_ctx$subjectInfoData3 = _ctx.subjectInfoData) === null || _ctx$subjectInfoData3 === void 0 ? void 0 : _ctx$subjectInfoData3.name), 1), _createElementVNode("div", _hoisted_7, _toDisplayString((_ctx$subjectInfoData4 = _ctx.subjectInfoData) === null || _ctx$subjectInfoData4 === void 0 ? void 0 : _ctx$subjectInfoData4.brief), 1), _createElementVNode("div", _hoisted_8, " 官网网站：" + _toDisplayString((_ctx$subjectInfoData5 = _ctx.subjectInfoData) === null || _ctx$subjectInfoData5 === void 0 ? void 0 : _ctx$subjectInfoData5.source_link), 1)])])]), _createElementVNode("section", _hoisted_9, [_createVNode(_component_update_time), _ctx.subjectTab.length ? (_openBlock(), _createBlock(_component_el_tabs, {
        key: 0,
        modelValue: _ctx.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.activeName = $event),
        class: "subject-tabs"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectTab, item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.key,
            label: item.label,
            name: item.key
          }, {
            default: _withCtx(() => [item.key === 'search' ? (_openBlock(), _createBlock(_component_newslist, {
              key: 0
            })) : _createCommentVNode("", true), item.key === 'plateform' ? (_openBlock(), _createBlock(_component_platform, {
              key: 1
            })) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["label", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_10, _hoisted_11], 64))];
    }),
    _: 1
  });
}